/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AddDutyRosterShift,
  DateOnlyCastTimeListTuple,
  DeleteShiftRequest,
  DutyRosterDto,
  EditDutyRosterShift,
  GetMyDutyRosterEntriesParams,
  GetMyTimeAccountSumValuesParams,
  GetTasksParams,
  VerifyDutyDayRequest,
  WorkingTimeAccountDto
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetMyTimeAccountSumValuesUrl = (params?: GetMyTimeAccountSumValuesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/DutyRoster/GetMyTimeAccountSumValues?${stringifiedParams}` : `/api/DutyRoster/GetMyTimeAccountSumValues`
}

export const getMyTimeAccountSumValues = async (params?: GetMyTimeAccountSumValuesParams, options?: Parameters<typeof customInstance>[1]): Promise<WorkingTimeAccountDto[]> => {

  return customInstance<WorkingTimeAccountDto[]>(getGetMyTimeAccountSumValuesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyTimeAccountSumValuesQueryKey = (params?: GetMyTimeAccountSumValuesParams,) => {
    return [
    `/api/DutyRoster/GetMyTimeAccountSumValues`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMyTimeAccountSumValuesQueryOptions = <TData = Awaited<ReturnType<typeof getMyTimeAccountSumValues>>, TError = ErrorType<unknown>>(params?: GetMyTimeAccountSumValuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyTimeAccountSumValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyTimeAccountSumValuesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyTimeAccountSumValues>>> = ({ signal }) => getMyTimeAccountSumValues(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyTimeAccountSumValues>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyTimeAccountSumValuesQueryResult = NonNullable<Awaited<ReturnType<typeof getMyTimeAccountSumValues>>>
export type GetMyTimeAccountSumValuesQueryError = ErrorType<unknown>


export function useGetMyTimeAccountSumValues<TData = Awaited<ReturnType<typeof getMyTimeAccountSumValues>>, TError = ErrorType<unknown>>(
 params: undefined |  GetMyTimeAccountSumValuesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyTimeAccountSumValues>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyTimeAccountSumValues>>,
          TError,
          Awaited<ReturnType<typeof getMyTimeAccountSumValues>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyTimeAccountSumValues<TData = Awaited<ReturnType<typeof getMyTimeAccountSumValues>>, TError = ErrorType<unknown>>(
 params?: GetMyTimeAccountSumValuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyTimeAccountSumValues>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyTimeAccountSumValues>>,
          TError,
          Awaited<ReturnType<typeof getMyTimeAccountSumValues>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyTimeAccountSumValues<TData = Awaited<ReturnType<typeof getMyTimeAccountSumValues>>, TError = ErrorType<unknown>>(
 params?: GetMyTimeAccountSumValuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyTimeAccountSumValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyTimeAccountSumValues<TData = Awaited<ReturnType<typeof getMyTimeAccountSumValues>>, TError = ErrorType<unknown>>(
 params?: GetMyTimeAccountSumValuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyTimeAccountSumValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyTimeAccountSumValuesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMyTimeAccountSumValuesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMyTimeAccountSumValues>>, TError = ErrorType<unknown>>(params?: GetMyTimeAccountSumValuesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyTimeAccountSumValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyTimeAccountSumValuesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyTimeAccountSumValues>>> = ({ signal }) => getMyTimeAccountSumValues(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyTimeAccountSumValues>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetMyTimeAccountSumValuesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMyTimeAccountSumValues>>>
export type GetMyTimeAccountSumValuesSuspenseQueryError = ErrorType<unknown>


export function useGetMyTimeAccountSumValuesSuspense<TData = Awaited<ReturnType<typeof getMyTimeAccountSumValues>>, TError = ErrorType<unknown>>(
 params: undefined |  GetMyTimeAccountSumValuesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyTimeAccountSumValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyTimeAccountSumValuesSuspense<TData = Awaited<ReturnType<typeof getMyTimeAccountSumValues>>, TError = ErrorType<unknown>>(
 params?: GetMyTimeAccountSumValuesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyTimeAccountSumValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyTimeAccountSumValuesSuspense<TData = Awaited<ReturnType<typeof getMyTimeAccountSumValues>>, TError = ErrorType<unknown>>(
 params?: GetMyTimeAccountSumValuesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyTimeAccountSumValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyTimeAccountSumValuesSuspense<TData = Awaited<ReturnType<typeof getMyTimeAccountSumValues>>, TError = ErrorType<unknown>>(
 params?: GetMyTimeAccountSumValuesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyTimeAccountSumValues>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyTimeAccountSumValuesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMyDutyRosterEntriesUrl = (params?: GetMyDutyRosterEntriesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/DutyRoster/GetMyDutyRosterEntries?${stringifiedParams}` : `/api/DutyRoster/GetMyDutyRosterEntries`
}

export const getMyDutyRosterEntries = async (params?: GetMyDutyRosterEntriesParams, options?: Parameters<typeof customInstance>[1]): Promise<DutyRosterDto[]> => {

  return customInstance<DutyRosterDto[]>(getGetMyDutyRosterEntriesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyDutyRosterEntriesQueryKey = (params?: GetMyDutyRosterEntriesParams,) => {
    return [
    `/api/DutyRoster/GetMyDutyRosterEntries`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMyDutyRosterEntriesQueryOptions = <TData = Awaited<ReturnType<typeof getMyDutyRosterEntries>>, TError = ErrorType<unknown>>(params?: GetMyDutyRosterEntriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyDutyRosterEntries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyDutyRosterEntriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyDutyRosterEntries>>> = ({ signal }) => getMyDutyRosterEntries(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyDutyRosterEntries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyDutyRosterEntriesQueryResult = NonNullable<Awaited<ReturnType<typeof getMyDutyRosterEntries>>>
export type GetMyDutyRosterEntriesQueryError = ErrorType<unknown>


export function useGetMyDutyRosterEntries<TData = Awaited<ReturnType<typeof getMyDutyRosterEntries>>, TError = ErrorType<unknown>>(
 params: undefined |  GetMyDutyRosterEntriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyDutyRosterEntries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyDutyRosterEntries>>,
          TError,
          Awaited<ReturnType<typeof getMyDutyRosterEntries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyDutyRosterEntries<TData = Awaited<ReturnType<typeof getMyDutyRosterEntries>>, TError = ErrorType<unknown>>(
 params?: GetMyDutyRosterEntriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyDutyRosterEntries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyDutyRosterEntries>>,
          TError,
          Awaited<ReturnType<typeof getMyDutyRosterEntries>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyDutyRosterEntries<TData = Awaited<ReturnType<typeof getMyDutyRosterEntries>>, TError = ErrorType<unknown>>(
 params?: GetMyDutyRosterEntriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyDutyRosterEntries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyDutyRosterEntries<TData = Awaited<ReturnType<typeof getMyDutyRosterEntries>>, TError = ErrorType<unknown>>(
 params?: GetMyDutyRosterEntriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyDutyRosterEntries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyDutyRosterEntriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMyDutyRosterEntriesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMyDutyRosterEntries>>, TError = ErrorType<unknown>>(params?: GetMyDutyRosterEntriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyDutyRosterEntries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyDutyRosterEntriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyDutyRosterEntries>>> = ({ signal }) => getMyDutyRosterEntries(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyDutyRosterEntries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetMyDutyRosterEntriesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMyDutyRosterEntries>>>
export type GetMyDutyRosterEntriesSuspenseQueryError = ErrorType<unknown>


export function useGetMyDutyRosterEntriesSuspense<TData = Awaited<ReturnType<typeof getMyDutyRosterEntries>>, TError = ErrorType<unknown>>(
 params: undefined |  GetMyDutyRosterEntriesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyDutyRosterEntries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyDutyRosterEntriesSuspense<TData = Awaited<ReturnType<typeof getMyDutyRosterEntries>>, TError = ErrorType<unknown>>(
 params?: GetMyDutyRosterEntriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyDutyRosterEntries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyDutyRosterEntriesSuspense<TData = Awaited<ReturnType<typeof getMyDutyRosterEntries>>, TError = ErrorType<unknown>>(
 params?: GetMyDutyRosterEntriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyDutyRosterEntries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyDutyRosterEntriesSuspense<TData = Awaited<ReturnType<typeof getMyDutyRosterEntries>>, TError = ErrorType<unknown>>(
 params?: GetMyDutyRosterEntriesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyDutyRosterEntries>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyDutyRosterEntriesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDutyRosterAddShiftUrl = () => {




  return `/api/DutyRoster/AddShift`
}

export const dutyRosterAddShift = async (addDutyRosterShift?: AddDutyRosterShift, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getDutyRosterAddShiftUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addDutyRosterShift)
  }
);}





export const getDutyRosterAddShiftMutationKey = () => ['dutyRosterAddShift'] as const;

export const getDutyRosterAddShiftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dutyRosterAddShift>>, TError,DutyRosterAddShiftMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof dutyRosterAddShift>>, TError,DutyRosterAddShiftMutationVariables, TContext> => {

const mutationKey = getDutyRosterAddShiftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dutyRosterAddShift>>, DutyRosterAddShiftMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  dutyRosterAddShift(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DutyRosterAddShiftMutationResult = NonNullable<Awaited<ReturnType<typeof dutyRosterAddShift>>>
    export type DutyRosterAddShiftMutationBody = BodyType<AddDutyRosterShift> | undefined
    export type DutyRosterAddShiftMutationError = ErrorType<unknown>
    export type DutyRosterAddShiftMutationVariables = {data?: BodyType<AddDutyRosterShift>}

    export const useDutyRosterAddShift = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dutyRosterAddShift>>, TError,DutyRosterAddShiftMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dutyRosterAddShift>>,
        TError,
        DutyRosterAddShiftMutationVariables,
        TContext
      > => {
      return useMutation(getDutyRosterAddShiftMutationOptions(options), queryClient);
    }
    export const getDutyRosterEditShiftUrl = () => {




  return `/api/DutyRoster/EditShift`
}

export const dutyRosterEditShift = async (editDutyRosterShift?: EditDutyRosterShift, options?: Parameters<typeof customInstance>[1]): Promise<number> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<number>(getDutyRosterEditShiftUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(editDutyRosterShift)
  }
);}





export const getDutyRosterEditShiftMutationKey = () => ['dutyRosterEditShift'] as const;

export const getDutyRosterEditShiftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dutyRosterEditShift>>, TError,DutyRosterEditShiftMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof dutyRosterEditShift>>, TError,DutyRosterEditShiftMutationVariables, TContext> => {

const mutationKey = getDutyRosterEditShiftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof dutyRosterEditShift>>, DutyRosterEditShiftMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  dutyRosterEditShift(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DutyRosterEditShiftMutationResult = NonNullable<Awaited<ReturnType<typeof dutyRosterEditShift>>>
    export type DutyRosterEditShiftMutationBody = BodyType<EditDutyRosterShift> | undefined
    export type DutyRosterEditShiftMutationError = ErrorType<unknown>
    export type DutyRosterEditShiftMutationVariables = {data?: BodyType<EditDutyRosterShift>}

    export const useDutyRosterEditShift = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof dutyRosterEditShift>>, TError,DutyRosterEditShiftMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof dutyRosterEditShift>>,
        TError,
        DutyRosterEditShiftMutationVariables,
        TContext
      > => {
      return useMutation(getDutyRosterEditShiftMutationOptions(options), queryClient);
    }
    export const getDeleteShiftUrl = () => {




  return `/api/DutyRoster/DeleteShift`
}

export const deleteShift = async (deleteShiftRequest?: DeleteShiftRequest, options?: Parameters<typeof customInstance>[1]): Promise<number> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<number>(getDeleteShiftUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deleteShiftRequest)
  }
);}





export const getDeleteShiftMutationKey = () => ['deleteShift'] as const;

export const getDeleteShiftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteShift>>, TError,DeleteShiftMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteShift>>, TError,DeleteShiftMutationVariables, TContext> => {

const mutationKey = getDeleteShiftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteShift>>, DeleteShiftMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  deleteShift(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteShiftMutationResult = NonNullable<Awaited<ReturnType<typeof deleteShift>>>
    export type DeleteShiftMutationBody = BodyType<DeleteShiftRequest> | undefined
    export type DeleteShiftMutationError = ErrorType<unknown>
    export type DeleteShiftMutationVariables = {data?: BodyType<DeleteShiftRequest>}

    export const useDeleteShift = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteShift>>, TError,DeleteShiftMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteShift>>,
        TError,
        DeleteShiftMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteShiftMutationOptions(options), queryClient);
    }
    export const getChangeVerificationStatusUrl = () => {




  return `/api/DutyRoster/ChangeVerificationStatus`
}

export const changeVerificationStatus = async (verifyDutyDayRequest?: VerifyDutyDayRequest, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getChangeVerificationStatusUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(verifyDutyDayRequest)
  }
);}





export const getChangeVerificationStatusMutationKey = () => ['changeVerificationStatus'] as const;

export const getChangeVerificationStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeVerificationStatus>>, TError,ChangeVerificationStatusMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof changeVerificationStatus>>, TError,ChangeVerificationStatusMutationVariables, TContext> => {

const mutationKey = getChangeVerificationStatusMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeVerificationStatus>>, ChangeVerificationStatusMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  changeVerificationStatus(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeVerificationStatusMutationResult = NonNullable<Awaited<ReturnType<typeof changeVerificationStatus>>>
    export type ChangeVerificationStatusMutationBody = BodyType<VerifyDutyDayRequest> | undefined
    export type ChangeVerificationStatusMutationError = ErrorType<unknown>
    export type ChangeVerificationStatusMutationVariables = {data?: BodyType<VerifyDutyDayRequest>}

    export const useChangeVerificationStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeVerificationStatus>>, TError,ChangeVerificationStatusMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeVerificationStatus>>,
        TError,
        ChangeVerificationStatusMutationVariables,
        TContext
      > => {
      return useMutation(getChangeVerificationStatusMutationOptions(options), queryClient);
    }
    export const getGetTasksUrl = (params?: GetTasksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/DutyRoster/GetTasks?${stringifiedParams}` : `/api/DutyRoster/GetTasks`
}

export const getTasks = async (params?: GetTasksParams, options?: Parameters<typeof customInstance>[1]): Promise<DateOnlyCastTimeListTuple[]> => {

  return customInstance<DateOnlyCastTimeListTuple[]>(getGetTasksUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTasksQueryKey = (params?: GetTasksParams,) => {
    return [
    `/api/DutyRoster/GetTasks`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTasksQueryOptions = <TData = Awaited<ReturnType<typeof getTasks>>, TError = ErrorType<unknown>>(params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTasksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasks>>> = ({ signal }) => getTasks(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTasksQueryResult = NonNullable<Awaited<ReturnType<typeof getTasks>>>
export type GetTasksQueryError = ErrorType<unknown>


export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = ErrorType<unknown>>(
 params: undefined |  GetTasksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasks>>,
          TError,
          Awaited<ReturnType<typeof getTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = ErrorType<unknown>>(
 params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTasks>>,
          TError,
          Awaited<ReturnType<typeof getTasks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = ErrorType<unknown>>(
 params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTasks<TData = Awaited<ReturnType<typeof getTasks>>, TError = ErrorType<unknown>>(
 params?: GetTasksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTasksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetTasksSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTasks>>, TError = ErrorType<unknown>>(params?: GetTasksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTasksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTasks>>> = ({ signal }) => getTasks(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetTasksSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTasks>>>
export type GetTasksSuspenseQueryError = ErrorType<unknown>


export function useGetTasksSuspense<TData = Awaited<ReturnType<typeof getTasks>>, TError = ErrorType<unknown>>(
 params: undefined |  GetTasksParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasksSuspense<TData = Awaited<ReturnType<typeof getTasks>>, TError = ErrorType<unknown>>(
 params?: GetTasksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTasksSuspense<TData = Awaited<ReturnType<typeof getTasks>>, TError = ErrorType<unknown>>(
 params?: GetTasksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTasksSuspense<TData = Awaited<ReturnType<typeof getTasks>>, TError = ErrorType<unknown>>(
 params?: GetTasksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTasks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTasksSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






